import { render } from "./OverlayComponent.vue?vue&type=template&id=265ec5ae&scoped=true"
import script from "./OverlayComponent.vue?vue&type=script&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&lang=js"

import "./OverlayComponent.vue?vue&type=style&index=0&id=265ec5ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ec5ae"]])

export default __exports__